export const isCSR = (csrUser) => {
  return csrUser?.role?.roleName?.toLowerCase() === "csr";
};
